// src/components/brandCustomization/EmailCustomization/EmailStyleEditor.jsx
import React from 'react';
import { ColorPicker } from '../shared';

/**
 * EmailStyleEditor - Editor de estilos visuales para email templates
 */
const EmailStyleEditor = ({
    styles,
    onChange
}) => {
    return (
        <div className="mt-6 pt-6 border-t border-gray-200">
            <h4 className="text-sm font-semibold text-gray-900 mb-4 flex items-center">
                <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                Personalización Visual
            </h4>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {/* Colores del Header */}
                <ColorPicker
                    label="Color de Fondo del Header"
                    value={styles.headerBackgroundColor || '#DC2626'}
                    onChange={(value) => onChange('headerBackgroundColor', value)}
                    placeholder="#DC2626"
                />

                <ColorPicker
                    label="Color de Texto del Header"
                    value={styles.headerTextColor || '#FFFFFF'}
                    onChange={(value) => onChange('headerTextColor', value)}
                    placeholder="#FFFFFF"
                />

                {/* Colores del Body */}
                <ColorPicker
                    label="Color de Fondo del Body"
                    value={styles.bodyBackgroundColor || '#EFF6FF'}
                    onChange={(value) => onChange('bodyBackgroundColor', value)}
                    placeholder="#EFF6FF"
                />

                <ColorPicker
                    label="Color de Texto del Body"
                    value={styles.bodyTextColor || '#1F2937'}
                    onChange={(value) => onChange('bodyTextColor', value)}
                    placeholder="#1F2937"
                />

                {/* Colores del Botón */}
                <ColorPicker
                    label="Color de Fondo del Botón"
                    value={styles.buttonBackgroundColor || '#3B82F6'}
                    onChange={(value) => onChange('buttonBackgroundColor', value)}
                    placeholder="#3B82F6"
                />

                <ColorPicker
                    label="Color de Texto del Botón"
                    value={styles.buttonTextColor || '#FFFFFF'}
                    onChange={(value) => onChange('buttonTextColor', value)}
                    placeholder="#FFFFFF"
                />

                {/* Footer */}
                <ColorPicker
                    label="Color de Texto del Footer"
                    value={styles.footerTextColor || '#6B7280'}
                    onChange={(value) => onChange('footerTextColor', value)}
                    placeholder="#6B7280"
                />

                {/* Tipografía */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Familia de Fuente
                    </label>
                    <select
                        value={styles.fontFamily || 'Arial, sans-serif'}
                        onChange={(e) => onChange('fontFamily', e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <option value="Arial, sans-serif">Arial</option>
                        <option value="'Helvetica Neue', Helvetica, sans-serif">Helvetica</option>
                        <option value="'Times New Roman', Times, serif">Times New Roman</option>
                        <option value="Georgia, serif">Georgia</option>
                        <option value="'Courier New', Courier, monospace">Courier</option>
                        <option value="Verdana, sans-serif">Verdana</option>
                        <option value="'Trebuchet MS', sans-serif">Trebuchet MS</option>
                    </select>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Tamaño de Fuente
                    </label>
                    <select
                        value={styles.fontSize || '16px'}
                        onChange={(e) => onChange('fontSize', e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <option value="12px">12px (Pequeño)</option>
                        <option value="14px">14px (Normal)</option>
                        <option value="16px">16px (Mediano)</option>
                        <option value="18px">18px (Grande)</option>
                        <option value="20px">20px (Muy Grande)</option>
                    </select>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Radio de Borde
                    </label>
                    <select
                        value={styles.borderRadius || '8px'}
                        onChange={(e) => onChange('borderRadius', e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <option value="0px">Sin borde (0px)</option>
                        <option value="4px">Pequeño (4px)</option>
                        <option value="8px">Mediano (8px)</option>
                        <option value="12px">Grande (12px)</option>
                        <option value="16px">Muy Grande (16px)</option>
                        <option value="24px">Redondeado (24px)</option>
                    </select>
                </div>
            </div>
        </div>
    );
};

export default EmailStyleEditor;

